var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcelone({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_307",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29022",
    "data-name": "Group 29022",
    transform: "translate(-4191 4996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4191, -4996)",
    filter: "url(#Ellipse_307)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_307-2",
    "data-name": "Ellipse 307",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-barcelona-fc",
    transform: "translate(4208 -4982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50608",
    "data-name": "Path 50608",
    d: "M34.852,19.194c-3.8-4.108-4.264-8.217-1.318-12.093l.078-.155L32.139,4.93l-.155.078a8.38,8.38,0,0,1-7.674-.93L24.155,4,24,4.078c-3.1,2.171-6.046,2.171-9.07,0L14.853,4l-.155.078a8.4,8.4,0,0,1-7.674.93L6.946,4.93,5.4,7.023l.078.078c2.946,3.953,2.558,7.907-1.318,12.093L4,19.349,5.55,20.9c-.155,7.287,3.8,11.55,11.628,12.17L19.5,35.007l2.4-1.938a13.721,13.721,0,0,0,7.519-2.558c2.791-2.171,4.186-5.349,4.108-9.612l1.55-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50609",
    "data-name": "Path 50609",
    d: "M32.31,25.9H8.977a8.442,8.442,0,0,0,1.705,6.589c1.628,1.938,4.419,3.1,7.907,3.411h4.031c3.411-.155,6.124-1.318,7.829-3.256A8.963,8.963,0,0,0,32.31,25.9Zm-8.217,4.806a3.4,3.4,0,0,1-1.008,2.4,3.544,3.544,0,0,1-2.4,1.008h0a3.4,3.4,0,0,1-2.4-5.814,3.544,3.544,0,0,1,2.4-1.008h0a3.4,3.4,0,0,1,2.4,1.008,3.346,3.346,0,0,1,1.008,2.4Z",
    transform: "translate(-1.101 -4.923)",
    fill: "#0d47a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50610",
    "data-name": "Path 50610",
    d: "M28.73,22.885h-.853v.7h.853A.363.363,0,0,0,28.73,22.885ZM28.653,21.8H27.8v.543h.853C28.885,22.265,29.04,21.878,28.653,21.8Z",
    transform: "translate(-5.351 -4.002)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50611",
    "data-name": "Path 50611",
    d: "M30.164,33.629a9.3,9.3,0,0,1-3.411,1.628h-.078v-9.38h3.488ZM16.288,35.257v-9.38H12.8v7.752a12.053,12.053,0,0,0,3.488,1.628Zm5.271-1.163h0a3.6,3.6,0,0,1-1.783-.465V35.8h3.488V33.707A4.225,4.225,0,0,1,21.56,34.094Zm0-6.822h0a3.319,3.319,0,0,1,1.705.465V25.8H19.777v1.938A4.328,4.328,0,0,1,21.56,27.273Z",
    transform: "translate(-1.978 -4.901)",
    fill: "#c62828"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50612",
    "data-name": "Path 50612",
    d: "M20.975,29.308a2.669,2.669,0,0,0,.388,2.558,1.208,1.208,0,0,1-.93.465,2.476,2.476,0,0,1-.233-1.085A2.691,2.691,0,0,1,20.975,29.308Zm.31,4.264c1.705-.155,2.713-.7,3.1-1.628a1,1,0,0,0-.465-.7c-.155-.078-.31,0-.543.078a1.612,1.612,0,0,1-.853.93c-.078,0-.155.078-.31.078a1.437,1.437,0,0,1-.543-.155L21.6,32.1a1.583,1.583,0,0,1-1.008.62A4.112,4.112,0,0,0,21.285,33.571ZM22.6,28.378a2.718,2.718,0,0,0-1.085.465c-.388,1.473-.465,2.481.388,3.023a.983.983,0,0,0,.465.078,1.221,1.221,0,0,0,.543-.543c-.388-.31-.853-.853-.155-1.86A1.692,1.692,0,0,1,22.6,28.378ZM26.169,30.7a2.832,2.832,0,0,0-.853-1.55,3,3,0,0,0-2.093-.853q-.465.349,0,.93A3.288,3.288,0,0,1,26.169,30.7Zm0,.775c-.465-.775-1.628-2.171-2.946-1.86-.62.7-.31,1.008,0,1.318a1.018,1.018,0,0,1,.93-.078,1.327,1.327,0,0,1,.7.853,1.1,1.1,0,0,1,.7.078,1.39,1.39,0,0,1,.543.388C26.091,32.021,26.169,31.788,26.169,31.478Zm-2.946,2.791a3,3,0,0,0,2.093-.853,1.394,1.394,0,0,0,.465-.7.7.7,0,0,0-.465-.465.983.983,0,0,0-.465-.078,3.582,3.582,0,0,1-2.946,1.783,3.652,3.652,0,0,0,1.318.31Z",
    transform: "translate(-3.642 -5.463)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50613",
    "data-name": "Path 50613",
    d: "M34.237,19.6h0c-3.566-3.876-3.953-8.6-1.24-12.325h0l-.775-1.163h-.078a8.681,8.681,0,0,1-7.519-.93L24.547,5.1l-.078.155a7.561,7.561,0,0,1-9.225,0l-.078-.078-.078.078a8.661,8.661,0,0,1-7.442.93H7.571L6.64,7.271l.078.078c4.108,5.659.078,10.775-1.24,12.248l-.078.078,1.24,1.318a10.59,10.59,0,0,0,2.326,8.062c1.938,2.171,4.961,3.411,8.76,3.643L19.741,34.4,21.756,32.7c1.318,0,5.814-.388,8.76-3.566q2.791-3.023,2.326-8.139ZM8.5,16.728a9.445,9.445,0,0,0-.388-8.992l-.233-.388.465.078a10.382,10.382,0,0,0,6.667-.93l.155-.078.078.078a8.816,8.816,0,0,0,9.147,0l.078-.078.078.078C26.175,7.5,27.958,7.813,31.136,7.5h.388l-.078.31a9.313,9.313,0,0,0-.31,8.915l.155.31H8.5Zm15.349,3.721H22.144V17.425h1.628a.791.791,0,0,1,.465,1.4A.9.9,0,0,1,23.849,20.449Zm-4.806-1.008a.79.79,0,0,0,.62.388.491.491,0,0,0,.465-.388h0l.62.31h0a1.166,1.166,0,0,1-1.085.775h-.233a1.723,1.723,0,0,1-1.008-.62,2.184,2.184,0,0,1-.078-1.86,1.2,1.2,0,0,1,1.163-.7h0a1.468,1.468,0,0,1,1.24.7h0l-.62.31h0a.672.672,0,0,0-.543-.31h0a.785.785,0,0,0-.543.31A1.063,1.063,0,0,0,19.043,19.441Zm-2.713-.93v.62H15.4v1.24h-.62V17.425h2.248v.62h-1.55v.465ZM29.973,28.2c-1.783,2.015-4.574,3.178-8.139,3.411H17.8c-3.721-.233-6.512-1.473-8.294-3.566-1.55-1.783-2.093-4.186-1.783-7.054v-.233H31.834v.233A8.981,8.981,0,0,1,29.973,28.2Z",
    transform: "translate(-0.315 -0.247)",
    fill: "#ffc107"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50614",
    "data-name": "Path 50614",
    d: "M20.553,17.167V8.718a9.083,9.083,0,0,1-4.5-1.318A10.113,10.113,0,0,1,9.7,8.408a9.993,9.993,0,0,1,.31,8.682Z",
    transform: "translate(-1.281 -0.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50615",
    "data-name": "Path 50615",
    d: "M35.053,8.508C32.184,8.74,30.324,8.43,28.7,7.5a9.964,9.964,0,0,1-4.5,1.318V17.19H34.665A10.278,10.278,0,0,1,35.053,8.508Z",
    transform: "translate(-4.541 -0.787)",
    fill: "#ffeb3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50616",
    "data-name": "Path 50616",
    d: "M30.535,17.167h-1.24V8.485c.388,0,.775.078,1.24.078ZM23.48,8.408a8.561,8.561,0,0,1-1.24.233v8.527h1.24Zm4.729-.078c-.465-.078-.853-.233-1.24-.31v9.147h1.24Zm-2.4-.853h0c-.465.155-.853.388-1.24.543v9.147h1.24Zm-4.961,3.566H17.589V8.02a8.473,8.473,0,0,1-1.163-.62,10.532,10.532,0,0,1-2.171.853v2.713H11a9.59,9.59,0,0,1,.078,3.333h3.178v2.868h3.333V14.377h3.256Z",
    transform: "translate(-1.574 -0.764)",
    fill: "#ff1744"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcelone);
export default __webpack_public_path__ + "static/media/barcelone.e580ac78b3d7a8dd4842b21db8307037.svg";
export { ForwardRef as ReactComponent };